import {AbstractControl, ValidatorFn} from '@angular/forms';
import {formatCurrencyToNumeric} from '../_utils/payment-utils';

export function currency(required: boolean, min: number, max: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const errors: any = {};
        if (required && !control.value) {
            errors.required = true;
        } else {
            const regex = /(?=.*\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|0)?(\.\d{1,2})?$/;
            if (!!control.value && !regex.test(control.value)) {
                errors.invalidFormat = true;
            } else {
                const value = control.value;
                const numericValue = typeof value === 'string' ? formatCurrencyToNumeric(value) : value;
                if ((!!max || max === 0) && numericValue > max) {
                    errors.max = true;
                }
                if ((!!min || min === 0) && numericValue < min) {
                    errors.min = true;
                }
            }
        }

        if (Object.keys(errors).length > 0) {
            return errors;
        } else {
            return null;
        }
    };
}
